var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tenancy-view-info-wrapper" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "small-12 medium-12 large-12 columns contact-column" },
          [
            _c(
              "div",
              { staticClass: "column-content" },
              [
                _c("div", { staticClass: "contact-section" }, [
                  _c(
                    "div",
                    { staticClass: "confirm-box" },
                    [
                      _c("TenantConfirm"),
                      _vm._v(" "),
                      _c("div", { staticClass: "confirm-box__row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "confirm-message float-left text-left",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "last-confirm last-confirm__text",
                              },
                              [_vm._v(_vm._s(_vm.lastUpdateOrConfirmText))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showConfirmBtn
                          ? _c(
                              "div",
                              {
                                staticClass: "confirm-btn float-left text-left",
                              },
                              [
                                _c("TenantConfirmModal", {
                                  ref: "TenantConfirmModalRef",
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn--orange",
                                    on: {
                                      click: function ($event) {
                                        return _vm.$refs.TenantConfirmModalRef.open()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t("tenancy.confirmContact")
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "change-history float-right text-right",
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "all-ecircular-link",
                                on: {
                                  click: function ($event) {
                                    return _vm.$refs.historiesModal.open()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("tenancy.changeHistory")) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "contact-section-header clearboth" },
                    [
                      _c("span", { staticClass: "contact-section-header" }, [
                        _vm._v(
                          _vm._s(_vm.$t("tenancy.table.eCircularContacts"))
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.canReadEcircular
                        ? _c("div", { staticClass: "float-right text-right" }, [
                            _c(
                              "a",
                              {
                                staticClass: "all-ecircular-link",
                                on: { click: _vm.goToAllECircularPage },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("eCircular.viewAll")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c("table", { staticClass: "contacts-table" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        { staticClass: "table-header-height" },
                        _vm._l(_vm.eCircluarHeaders, function (header, index) {
                          return _c("th", { key: index, class: header.class }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(header.name) +
                                "\n                "
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.circleContacts, function (item, index) {
                        return _c(
                          "tr",
                          {
                            key: index,
                            staticClass: "table-body-row__height",
                            class: { expired: item.isExpired },
                          },
                          [
                            _c("td", { staticClass: "select-column" }, [
                              _c("input", {
                                directives: [
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                ],
                                staticClass: "primary-radio-button",
                                attrs: {
                                  type: "radio",
                                  name: "primaryPerson",
                                  disabled: true,
                                },
                                domProps: {
                                  checked: _vm.deep(
                                    item,
                                    "CompanyContact.cPrimary"
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "number-column" }, [
                              _vm.canAccessContact
                                ? _c("div", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "name-hyper-link",
                                        on: {
                                          click: function ($event) {
                                            return _vm.navToContactDetail(
                                              item.id,
                                              false
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.displayI18nFullName(
                                                item.firstName,
                                                item.lastName
                                              ) || item.name
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.isEngineer
                                      ? _c("i", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !!item.remarks,
                                              expression: "!!item.remarks",
                                            },
                                          ],
                                          staticClass: "remark-included-flag",
                                        })
                                      : _vm._e(),
                                  ])
                                : _c("div", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.displayI18nFullName(
                                            item.firstName,
                                            item.lastName
                                          ) || item.name
                                        ) +
                                        "\n                  "
                                    ),
                                  ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "number-column" }, [
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("isEmptyValue")(item.phone))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "number-column" }, [
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("isEmptyValue")(
                                        _vm
                                          .deep(item, "CompanyContact.cEmails")
                                          .join(", ")
                                      )
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "number-column" }, [
                              _c("div", {}, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm._f("isEmptyValue")(
                                        (
                                          _vm.deep(
                                            item,
                                            "CompanyContact.cFloor"
                                          ) || []
                                        ).join(", ")
                                      )
                                    ) +
                                    "\n                  "
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "contact-section" }, [
                  _c("p", { staticClass: "contact-section-header" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tenancy.emergencyDuringOfficeHours")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("table", { staticClass: "contacts-table" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        { staticClass: "table-header-height" },
                        _vm._l(_vm.emergencyHeaders, function (header, index) {
                          return _c("th", { key: index, class: header.class }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(header.name) +
                                "\n                "
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(
                        _vm.emergencyWorkingContacts,
                        function (item, index) {
                          return _c(
                            "tr",
                            {
                              key: index,
                              staticClass: "table-body-row__height",
                            },
                            [
                              _c("td", { staticClass: "select-column" }, [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("isEmptyValue")(
                                        _vm.ordinalNumber(
                                          _vm.deep(
                                            item,
                                            "CompanyContact.workingHourOrder"
                                          )
                                        )
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "number-column" }, [
                                _vm.canAccessContact
                                  ? _c("div", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "name-hyper-link",
                                          on: {
                                            click: function ($event) {
                                              return _vm.navToContactDetail(
                                                item.id,
                                                false
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.displayI18nFullName(
                                                  item.firstName,
                                                  item.lastName
                                                ) || item.name
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isEngineer
                                        ? _c("i", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !!item.remarks,
                                                expression: "!!item.remarks",
                                              },
                                            ],
                                            staticClass: "remark-included-flag",
                                          })
                                        : _vm._e(),
                                    ])
                                  : _c("div", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.displayI18nFullName(
                                              item.firstName,
                                              item.lastName
                                            ) || item.name
                                          ) +
                                          "\n                  "
                                      ),
                                    ]),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "number-column" }, [
                                _c("div", [
                                  _vm._v(_vm._s(_vm.getAllPhones(item))),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "number-column" }, [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(_vm._f("isEmptyValue")(item.email))
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "number-column" }, [
                                _c("div", [
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("isEmptyValue")(
                                          _vm.deep(
                                            item,
                                            "CompanyContact.oRemarks"
                                          )
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "contact-section" }, [
                  _c("p", { staticClass: "contact-section-header" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tenancy.emergencyAfterOfficeHours")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("table", { staticClass: "contacts-table" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        { staticClass: "table-header-height" },
                        _vm._l(_vm.emergencyHeaders, function (header, index) {
                          return _c("th", { key: index, class: header.class }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(header.name) +
                                "\n                "
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(
                        _vm.emergencyNonWorkingContacts,
                        function (item, index) {
                          return _c(
                            "tr",
                            {
                              key: index,
                              staticClass: "table-body-row__height",
                            },
                            [
                              _c("td", { staticClass: "select-column" }, [
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("isEmptyValue")(
                                          _vm.ordinalNumber(
                                            _vm.deep(
                                              item,
                                              "CompanyContact.nonWorkingHourOrder"
                                            )
                                          )
                                        )
                                      )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "number-column" }, [
                                _vm.canAccessContact
                                  ? _c("div", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "name-hyper-link",
                                          on: {
                                            click: function ($event) {
                                              return _vm.navToContactDetail(
                                                item.id,
                                                false
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.displayI18nFullName(
                                                  item.firstName,
                                                  item.lastName
                                                ) || item.name
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isEngineer
                                        ? _c("i", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !!item.remarks,
                                                expression: "!!item.remarks",
                                              },
                                            ],
                                            staticClass: "remark-included-flag",
                                          })
                                        : _vm._e(),
                                    ])
                                  : _c("div", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.displayI18nFullName(
                                              item.firstName,
                                              item.lastName
                                            ) || item.name
                                          ) +
                                          "\n                  "
                                      ),
                                    ]),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "number-column" }, [
                                _c("div", [
                                  _vm._v(" " + _vm._s(_vm.getAllPhones(item))),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "number-column" }, [
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("isEmptyValue")(item.email))
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "number-column" }, [
                                _c("div", [
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("isEmptyValue")(
                                          _vm.deep(
                                            item,
                                            "CompanyContact.oRemarks"
                                          )
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("FireMarshalContact"),
                _vm._v(" "),
                _vm.isRetail
                  ? _c("div", [
                      _vm.canEditMarketing && _vm.isRetail
                        ? _c(
                            "div",
                            [
                              _c("MarketingContact", {
                                ref: "marketingContact",
                                attrs: {
                                  tenancyId: _vm.tenancyId,
                                  allowLinkContacts: _vm.allowLinkContacts,
                                  linkFunc: _vm.linkFunc,
                                },
                              }),
                            ],
                            1
                          )
                        : _c("div", { staticClass: "contact-section" }, [
                            _c("p", { staticClass: "contact-section-header" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("tenancy.table.marketing")) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("table", { staticClass: "contacts-table" }, [
                              _c("thead", [
                                _c(
                                  "tr",
                                  { staticClass: "table-header-height" },
                                  _vm._l(
                                    _vm.marketingHeaders,
                                    function (header, index) {
                                      return _c(
                                        "th",
                                        { key: index, class: header.class },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(header.name) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.marketingContacts,
                                  function (item, index) {
                                    return _c(
                                      "tr",
                                      {
                                        key: index,
                                        staticClass: "table-body-row__height",
                                      },
                                      [
                                        _c(
                                          "td",
                                          { staticClass: "number-column" },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("isEmptyValue")(
                                                      _vm
                                                        .deep(
                                                          item,
                                                          "CompanyContact.roleType"
                                                        )
                                                        .join(", ")
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "number-column" },
                                          [
                                            _vm.canAccessContact
                                              ? _c("div", [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "name-hyper-link",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.navToContactDetail(
                                                            item.id,
                                                            false
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.displayI18nFullName(
                                                              item.firstName,
                                                              item.lastName
                                                            ) || item.name
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.isEngineer
                                                    ? _c("i", {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              !!item.remarks,
                                                            expression:
                                                              "!!item.remarks",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "remark-included-flag",
                                                      })
                                                    : _vm._e(),
                                                ])
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.displayI18nFullName(
                                                          item.firstName,
                                                          item.lastName
                                                        ) || item.name
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "number-column" },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("isEmptyValue")(
                                                      item.phone
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "number-column" },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("isEmptyValue")(
                                                      _vm
                                                        .deep(
                                                          item,
                                                          "CompanyContact.mEmails"
                                                        )
                                                        .join(", ")
                                                    )
                                                  )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "number-column" },
                                          [
                                            _c("div", [
                                              _c("pre", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isEmptyValue")(
                                                      _vm.deep(
                                                        item,
                                                        "CompanyContact.mRemarks"
                                                      )
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "contact-section" }, [
                  _c("p", { staticClass: "contact-section-header" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tenancy.table.allContacts")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("table", { staticClass: "contacts-table" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        { staticClass: "table-header-height" },
                        _vm._l(_vm.otherHeaders, function (header, index) {
                          return _c("th", { key: index, class: header.class }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(header.name) +
                                "\n                "
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.otherContacts, function (item, index) {
                        return _c(
                          "tr",
                          { key: index, staticClass: "table-body-row__height" },
                          [
                            _c("td", { staticClass: "number-column" }, [
                              _vm.canAccessContact
                                ? _c("div", [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "name-hyper-link",
                                        on: {
                                          click: function ($event) {
                                            return _vm.navToContactDetail(
                                              item.id,
                                              false
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.displayI18nFullName(
                                                item.firstName,
                                                item.lastName
                                              ) || item.name
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.isEngineer
                                      ? _c("i", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !!item.remarks,
                                              expression: "!!item.remarks",
                                            },
                                          ],
                                          staticClass: "remark-included-flag",
                                        })
                                      : _vm._e(),
                                  ])
                                : _c("div", [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.displayI18nFullName(
                                            item.firstName,
                                            item.lastName
                                          ) || item.name
                                        ) +
                                        "\n                  "
                                    ),
                                  ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "number-column" }, [
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("isEmptyValue")(
                                        _vm.deep(item, "CompanyContact.title")
                                      )
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "number-column" }, [
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("isEmptyValue")(item.phone))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "number-column" }, [
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._f("isEmptyValue")(item.email))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "number-column" }, [
                              _c("div", [
                                _vm._v(" " + _vm._s(_vm.calcRoleType(item))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "number-column" },
                              [
                                _vm._l(
                                  _vm.remarksFieldMap,
                                  function (mapItem, mapIndex) {
                                    return [
                                      mapItem.shouldShow(item)
                                        ? _c(
                                            "div",
                                            { key: mapIndex, class: mapIndex },
                                            [
                                              mapIndex !== "oRemarks"
                                                ? _c("br")
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("pre", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isEmptyValue")(
                                                      mapItem.componentVal(item)
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("TenancyHistoriesModal", { ref: "historiesModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }